import {Component} from "@angular/core";
import {Router, ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-redirect',
  template: ''
})
export class RedirectComponent {

  constructor(private router: Router, private route: ActivatedRoute) {
    this.route.params.subscribe(
      params => {
        let url = params['url'];
        let decodedUrl = decodeURIComponent(url);
        this.router.navigateByUrl(decodedUrl);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/redirect/redirect.component.ts